import Http from "../http";

// SAM-257: the writes below return `{ success: false, data: null }` on
// failure. They used to return `[]` — truthy, and with an undefined `success`
// — so `if (response.success)` callers failed closed by luck while callers
// reading `response.data._id` got a TypeError instead of an error message.
// jobtype.controller.ts replies `{ success, data }` on both paths. Reads keep
// `[]`.

export const getJobTypeList = async (fromFilters) => {
  const path = `/v2/jobtype?fromFilters=${fromFilters ? fromFilters : false}`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path);
    return response.data;
  } catch (e) {
    return [];
  }
};

export const getJobType = async (params) => {
  const path = `/v2/jobtype/${params.id}`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path);
    return response.data;
  } catch (e) {
    return [];
  }
};

export const createJobType = async (params) => {
  const path = `/v2/jobtype`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const updateJobType = async ({ title, icon, id, settings }) => {
  const path = `/v2/jobtype/${id}`;
  try {
    const saveData = {
      title: title,
      icon: icon,
    };
    if (settings) {
      saveData.settings = settings;
    }
    const response = await Http.sharedInstance.withAuth().put(path, saveData);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};

export const deleteJobType = async ({ id }) => {
  const path = `/v2/jobtype/${id}`;
  try {
    const response = await Http.sharedInstance.withAuth().delete(path);
    return response.data;
  } catch (e) {
    return { success: false, data: null };
  }
};
